import React, { useState } from "react";
import { Box, Button, getColor, InputField, Modal, Typography } from "fds";
import "./index.scss";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import SuccessIcon from "../../shared/icons/SuccessIcon";
import { useTranslation } from "react-i18next";

interface FindPasswordModalProps {
  open: boolean;
  onClose: () => void;
  changeLoading: (status: boolean) => void;
}
const FindPasswordModal: React.FC<FindPasswordModalProps> = ({
  open,
  onClose,
  changeLoading,
}) => {
  /** hook 정리 **/
  const { t } = useTranslation();
  const { sendPasswordInit } = useLoginStore();

  /** State 정리 **/
  const [userId, changeUserId] = useState("");
  const [err, setErr] = useState("");
  const [step, changeStep] = useState<"input" | "success">("input");

  /** 함수 정리 **/
  /** 비밀번호를 찾기 전, 사용자 존재 확인 */
  const handleSendFindPasswordRequest = async () => {
    /** error 1 : input 이 없을 경우 */
    if (!userId) {
      setErr(t("login.findPW.userIdPlaceholder"));
    } else {
      changeLoading(true);
      let resp: any = await sendPasswordInit(userId);
      if (resp.payload && resp.payload.code === "success") {
        changeLoading(false);
        setErr("");
        changeStep("success");
      } else {
        changeLoading(false);
        /** error 2 : 존재하지 않는 사용자일 경우 */
        setErr(t("login.findPW.notFoundUser"));
      }
    }
    return;
  };
  return step === "input" ? (
    <Modal
      open={open}
      onClose={onClose}
      title={t("login.login.findPW")}
      width={540}
      body={
        <Box direction="column">
          <Typography
            type="body2_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("login.findPW.typeUserId")}
          </Typography>
          <InputField
            placeholder={t("login.findPW.userIdPlaceholder")}
            size="md"
            value={userId}
            onChange={(e) => changeUserId(e.target.value)}
            label="Wrapsody eCo ID"
            classes="mg mt-32"
            maxLength={64}
            isError={err !== ""}
            helpMessage={err}
            onKeyUp={(e) =>
              e.code === "Enter" && handleSendFindPasswordRequest()
            }
          />
        </Box>
      }
      footer={
        <Box>
          <Button
            btnStyle="fill"
            type="secondary"
            label={t("common.cancel")}
            onClick={onClose}
          />
          <Button
            btnStyle="fill"
            label={t("common.sendMail")}
            onClick={handleSendFindPasswordRequest}
            state={userId ? "default" : "disable"}
          />
        </Box>
      }
    />
  ) : (
    <Modal open={open} onClose={onClose} width={540} isCustom height={310}>
      <Box
        direction="column"
        alignItems="center"
        justifyContent="center"
        width={"100%"}
        height={"100%"}
      >
        <SuccessIcon />
        <Typography type="h3" classes="mg mt-24">
          {t("login.findPW.sendMail")}
        </Typography>
        <Typography
          type="body4_rg"
          classes="mg mt-20"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
        >
          {t("login.findPW.checkMailBox")}
        </Typography>
        <Button
          btnStyle="fill"
          label={t("common.confirm")}
          classes="mg mt-32"
          onClick={onClose}
        />
      </Box>
    </Modal>
  );
};
export default FindPasswordModal;
